module.exports = __webpack_public_path__ + "img/6-1.96a3b7a2.png";